import { render } from "./LookUp.vue?vue&type=template&id=88d735f2&scoped=true"
import script from "./LookUp.vue?vue&type=script&lang=js"
export * from "./LookUp.vue?vue&type=script&lang=js"

import "./LookUp.vue?vue&type=style&index=0&id=88d735f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d735f2"]])

export default __exports__